import type { CmsMediaKind } from "./cms-media-labels";

/** Set after a CMS media upload (image/video/embed) saved directly via the API. */
let mediaUploadedInSession = false;
let lastUploadedKind: CmsMediaKind | null = null;

export function markCmsMediaUploaded(kind: CmsMediaKind) {
  mediaUploadedInSession = true;
  lastUploadedKind = kind;
}

/** Returns the uploaded media kind and clears the session flag, or null if none. */
export function consumeCmsMediaUploaded(): CmsMediaKind | null {
  if (!mediaUploadedInSession) return null;
  mediaUploadedInSession = false;
  const kind = lastUploadedKind;
  lastUploadedKind = null;
  return kind;
}
